/**
 * Shared Signup email normalization/format-check.
 * Mirrors the backend's authoritative EmailValidator.java format rule exactly,
 * so the two layers can never disagree about what counts as a valid format
 * (CR-129 — one authoritative policy, frontend mirrors it for UX).
 *
 * Practical SaaS format check (not an RFC-5322 parser): non-whitespace/non-@
 * local part, @, non-whitespace/non-@ domain part, a literal dot, non-
 * whitespace/non-@ suffix. Rejects missing @, missing domain suffix, and any
 * embedded whitespace. Ownership verification comes later from Wave-2 OTP, not
 * from format strictness here. Unicode email addresses are not part of this
 * rule's normative contract.
 */
export const normalizeEmail = (email) => (email || '').trim().toLowerCase();

export const isValidEmailFormat = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email || '');
